



































import {
  defineComponent,
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
} from '@vue/composition-api';
import { useStore } from '@/hooks/useStore';
import { hasMessageBoardAbility } from '@/lib/abilityHelper';

export default defineComponent({
  name: 'sp-header',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(_props, { emit }) {
    const store = useStore();
    const userState = store.state.user;
    const displayName = computed<string>(() => userState.display_name);
    const canMessageBoard = computed<boolean>(() => hasMessageBoardAbility(userState));
    const isMenuOpen = ref<boolean>(false);
    const refHeader = ref<HTMLElement>();

    const toggleMenu = (): void => {
      isMenuOpen.value = !isMenuOpen.value;
    };
    const onClickLogout = (): void => {
      emit('logout');
    };
    // メニュー外クリックで閉じる（Calendar.vue の document listener パターン踏襲）
    const onClickDocument = (evt: MouseEvent): void => {
      if (!isMenuOpen.value) return;
      if (!refHeader.value) return;

      const clickedNode = evt.target;
      if (clickedNode instanceof Node && !refHeader.value.contains(clickedNode)) {
        isMenuOpen.value = false;
      }
    };
    onMounted(() => document.addEventListener('click', onClickDocument));
    onBeforeUnmount(() => document.removeEventListener('click', onClickDocument));

    return {
      displayName,
      canMessageBoard,
      isMenuOpen,
      refHeader,
      toggleMenu,
      onClickLogout,
    };
  },
});
